import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'

import { useGlobalContext } from '../../../../context/ContextGlobal'
import {
  addDocument,
  deleteDocument,
  deleteSubDocument,
  generateIdSubDocument,
  getDocument,
  getDocumentsWithQuery,
  getDocumentsWithQuerys,
  getSubDocuments,
  setSubDocument,
  updateDocument,
} from '../../../../firebase/firestore'
import { TryCatch } from '../../../../utils/general'
import { ConvertTimestampToDateTime, ConvertToTimestamp, DateTimeNow, TimestampNow } from '../../../../utils/dates'

export const usePaymentsClients = () => {
  const { id } = useParams()
  const {
    user,
    loading,
    setLoading,
    setAlerts,
    infosContext,
    setDataContext,
    dataContext,
    formContext,
    setFormContext,
  } = useGlobalContext()

  const userName = user.user.nome

  const [search, setSearch] = useState('')
  const [modalHistory, setModalHistory] = useState(false)
  // const { FetchClientInfos } = useAdminClients()

  const navigate = useNavigate()

  const getForm = async () => {
    const payments = await getDocument('clientes', id)
    setFormContext({ ...payments })
  }

  const getData = async () => {
    // const cCodClientOmie = formContext?.cCodClientOmie || ''
    // // console.log(cCodClientOmie)
    // const query = [{ field: 'codigo_cliente_fornecedor', operator: '==', value: Number(cCodClientOmie) }]
    // const getPaymentsProssesing = await getDocumentsWithQuerys('_payments', query)
    const getPaymentsClient = await getSubDocuments('clientes', id, 'payments')

    const payments = [...getPaymentsClient].sort(
      (a, b) => ConvertToTimestamp(b.dt_created) - ConvertToTimestamp(a.dt_created),
    )
    setDataContext({ payments })
  }

  const consultOsOmie = async (payment) => {
    return setAlerts((prev) => [
      {
        type: 'error',
        title: 'Nota fiscal não encontrada' + payment,
        msg: 'Api da Omie desabilitada no sistema da keap staff',
      },
      ...prev,
    ])
    // const param = [
    //   {
    //     cCodIntOS: payment.idPayment,
    //     lPdfDemo: true,
    //     lPdfDest: true,
    //     lRps: true,
    //     lPdfRecibo: true,
    //   },
    // ]
    // const consultarOS = await OrdemDeServico().status(param)

    // const responseNFE =
    //   consultarOS.ListaRpsNfse && consultarOS.ListaRpsNfse.length > 0 ? consultarOS.ListaRpsNfse[0] : null

    // if (!responseNFE) {
    //   throw new Error('Nenhuma resposta válida na Omie para esta OS.')
    // }

    // const newResponseOmie = {
    //   cUrlPdfDemo: responseNFE?.cUrlPdfDemo || '',
    // }

    // // console.log(newResponseOmie)

    // // console.log(responseNFE)

    // const newPayment = {
    //   ...payment,
    //   responseOmie: {
    //     ...payment.responseOmie,
    //     ...newResponseOmie,
    //   },
    // }
    // // console.log(newPayment)

    // await updateSubDocument('clientes', id, 'payments', newPayment.id, newPayment)

    // if (newResponseOmie?.cUrlPdfDemo) {
    //   return window.open(newResponseOmie?.cUrlPdfDemo, '_blank')
    // } else {
    //   return setAlerts((prev) => [
    //     {
    //       type: 'error',
    //       title: 'Nota fiscal não encontrada',
    //       msg: 'Acesse o portal da omie, e verifique a situação dessa nota fiscal.',
    //     },
    //     ...prev,
    //   ])
    // }
  }

  const HandleConsultarOsOmie = async (value) => {
    await TryCatch(
      async () => {
        await consultOsOmie(value)
      },
      setLoading,
      setAlerts,
    )
  }

  const CalculateValueClient = async (idClient, dateCalculate = false) => {
    const getClient = await getDocument('clientes', idClient)

    const clientId = getClient.id
    const plans = getClient?.plans || []

    const now = Date.now()
    let date = new Date()

    if (dateCalculate) {
      const [ano, mes] = dateCalculate.split('-')
      date = new Date(Number(ano), Number(mes), 1) // força dia 1
    }

    if (plans.length === 0) {
      setAlerts((prev) => [
        {
          type: 'error',
          title: 'Nenhum Plano selecionado',
          msg: 'Não foi encontrado planos vinculados a esse cliente.',
        },
        ...prev,
      ])
      return {}
    }

    // Prioriza planos com dtEnd futuro
    const planoAtivo =
      plans
        .filter((p) => p.dtEnd && new Date(p.dtEnd).getTime() > now)
        .sort((a, b) => new Date(b.dtEnd).getTime() - new Date(a.dtEnd).getTime())[0] || plans.find((p) => !p.dtEnd)

    // mes passado
    const startOfLastMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1).getTime()
    const endOfLastMonth = new Date(date.getFullYear(), date.getMonth(), 0, 23, 59, 59, 999).getTime()

    // coleta eventos e staff do evento por cliente, por status não deletado e por data de criação
    const querys = [
      { field: 'clientId', operator: '==', value: clientId },
      { field: 'status', operator: '!=', value: 'deleted' },
      { field: 'timestampCreated', operator: '>=', value: startOfLastMonth },
      { field: 'timestampCreated', operator: '<=', value: endOfLastMonth },
    ]

    const eventsActives = await getDocumentsWithQuerys('events', querys)
    const statusFromBilling = [3, 5, 7, 8, 9, 10] // filtro da staff
    const getStaffWithEventsActives = eventsActives.map(async (event) => {
      const idEvent = event.id
      const getStaff = await getSubDocuments('events', idEvent, 'staff')
      const staff = getStaff.filter((candidate) => statusFromBilling.includes(candidate.status))
      return { event, staff }
    })

    const eventsWithStaff = await Promise.all(getStaffWithEventsActives)
    console.log('Total de eventos criados: ', eventsWithStaff.length)

    const totalStaff = eventsWithStaff.reduce((acc, curr) => acc + curr.staff.length, 0)
    console.log('Total de staff utilizados:', totalStaff)

    const totalStaffFromBilling = Math.max(0, totalStaff - Number(planoAtivo.staffLimit))
    console.log('staff a Cobrar:', totalStaffFromBilling)

    const valueTotalPerStaff = totalStaffFromBilling * Number(planoAtivo.valuePerStaff)
    const valuePayable = Number(planoAtivo.value)
    const totalPayment = valuePayable + valueTotalPerStaff

    const response = {
      dtStart: startOfLastMonth,
      dtEnd: endOfLastMonth,
      vPlanActive: planoAtivo,
      nStaffFree: Number(planoAtivo.staffLimit),
      nEventsTotal: eventsWithStaff.length,
      nStaffTotal: totalStaff,
      nStaffFromBilling: totalStaffFromBilling,
      vPerStaff: Number(planoAtivo.valuePerStaff),
      vPayment: valuePayable,
      vPaymentStaff: valueTotalPerStaff,
      vPaymentTotal: totalPayment,
    }

    return response
  }

  const newPayment = async () => {
    const isConfirmed = window.prompt('Tem certeza criar uma cobrança cobrança? Digite "CONFIRMAR" para continuar.')

    if (String(isConfirmed).toUpperCase() !== 'CONFIRMAR') {
      return setAlerts((prev) => [
        {
          type: 'error',
          title: 'Confirmação Recusada',
          msg: 'Para continuar com a operação é necessário confirmar.',
        },
        ...prev,
      ])
    }

    const dateCalculate = formContext?.dateCalculate

    const newCalculatePayment = await CalculateValueClient(id, dateCalculate)

    if (!newCalculatePayment?.vPaymentTotal) return

    const idPayment = await generateIdSubDocument('clientes', id, 'payments')

    const newPaymentData = {
      dt_created: DateTimeNow(),
      errors: 0,
      idPayment,
      idUser: id,
      name: 'Cobrança Mensal',
      status: 'awaitPayment',
      desc: `
Cobraça: ${ConvertTimestampToDateTime(newCalculatePayment.dtStart).split(' ')[0]} - ${ConvertTimestampToDateTime(newCalculatePayment.dtEnd).split(' ')[0]}

Total Eventos Criados: ${newCalculatePayment.nEventsTotal}
Staffs Utilizados: ${newCalculatePayment.nStaffTotal}
Valor do Staff a pagar: R$ ${newCalculatePayment.vPaymentStaff}
Valor Mensalidade: R$ ${newCalculatePayment.vPayment}
      
Total a Pagar: R$ ${newCalculatePayment.vPaymentTotal}
      `,
      type: 'payment',
      typeUser: 'client',
      typePayment: 'boleto',
      value: newCalculatePayment.vPaymentTotal,
      log: [
        {
          status: 'Pagamento Gerado Manualmente',
          time: TimestampNow(),
          origin: 'web/clients/newPayment/' + user.user.nome,
        },
      ],
    }

    await setSubDocument('clientes', id, 'payments', idPayment, newPaymentData)

    FetchGetData()

    return setAlerts((prev) => [
      {
        type: 'success',
        title: 'Pagamento gerado',
        msg: 'Um novo pagamento foi adicionado, aguarde o processamento do pagamento ser concluído.',
      },
      ...prev,
    ])
  }

  const HandleNewPayment = async () => {
    await TryCatch(newPayment, setLoading, setAlerts)
  }

  const confirmPayment = async (payment) => {
    const isConfirmed = window.prompt(
      'Tem certeza que deseja dar baixar nesta cobrança? Digite "CONFIRMAR" para continuar.',
    )

    if (String(isConfirmed).toUpperCase() !== 'CONFIRMAR') {
      return setAlerts((prev) => [
        {
          type: 'error',
          title: 'Confirmação Recusada',
          msg: 'Para continuar com a operação é necessário confirmar.',
        },
        ...prev,
      ])
    }

    const getClient = await getDocument('clientes', id)

    const trintaDiasEmMs = 30 * 24 * 60 * 60 * 1000

    const novoTimestamp = trintaDiasEmMs + getClient.nextPayment

    await updateDocument('clientes', id, { nextPayment: novoTimestamp })

    const newPaymentData = {
      ...payment,
      status: 'paymentSuccess',
      dt_payment: DateTimeNow(),
      log: [
        {
          status: 'Pagamento Recebido com sucesso',
          time: TimestampNow(),
          origin: 'web/clients/newPayment/' + user.user.nome,
        },
        ...(payment?.log || []),
      ],
    }

    await setSubDocument('clientes', id, 'payments', payment.idPayment, newPaymentData)

    return window.location.reload()
  }

  const HandleConfirmPayment = async (payment) => {
    const callback = async () => {
      await confirmPayment(payment)
    }
    await TryCatch(callback, setLoading, setAlerts)
  }

  const selectPayment = async (payment) => {
    setDataContext((prev) => ({ ...prev, paymentSelected: payment }))
    setModalHistory(true)
  }

  const CancelPayment = async (payment) => {
    const isConfirmed = window.prompt(
      'Tem certeza que deseja cancelar esta cobrança? Digite "CANCELAR" para continuar.',
    )

    if (String(isConfirmed).toUpperCase() !== 'CANCELAR') {
      return setAlerts((prev) => [
        {
          type: 'error',
          title: 'Confirmação Recusada',
          msg: 'Para continuar com a operação é necessário confirmar.',
        },
        ...prev,
      ])
    }

    delete payment.id

    // const getPaymentsActives = await getDocumentsWithQuery('_payments', 'idPayment', '==', id)

    // const promisses = getPaymentsActives.map(async (pay) => {
    //   await deleteDocument('_payments', pay.id)
    // })

    // await Promise.all(promisses)

    const newPaymentData = {
      ...payment,
      status: 'canceled',
      log: [
        {
          status: 'Solicitação de Cancelamento Enviado',
          time: TimestampNow(),
          origin: 'web/clients/newPayment/' + user.user.nome,
        },
        ...(payment?.log || []),
      ],
    }

    // await addDocument('_payments', newPaymentData)
    // await deleteSubDocument('clientes', id, 'payments', payment.idPayment)
    await setSubDocument('clientes', id, 'payments', payment.idPayment, newPaymentData)

    FetchGetData()

    return setAlerts((prev) => [
      {
        type: 'success',
        title: 'Solicitação de Cancelamento Enviado',
        msg: 'Processo de cancelamento em andamento, aguarde o processamento ser concluído.',
      },
      ...prev,
    ])
  }

  const DeletePayment = async (payment) => {
    const isConfirmed = window.prompt('Tem certeza que deseja excluir esta cobrança? Digite "EXCLUIR" para continuar.')

    if (String(isConfirmed).toUpperCase() !== 'EXCLUIR') {
      return setAlerts((prev) => [
        {
          type: 'error',
          title: 'Confirmação Recusada',
          msg: 'Para continuar com a operação é necessário confirmar.',
        },
        ...prev,
      ])
    }

    await deleteSubDocument('clientes', id, 'payments', payment.id)
    await FetchGetData()
    return setAlerts((prev) => [
      {
        type: 'success',
        title: 'Pagamento Deletado',
        msg: 'Para continuar com a operação é necessário confirmar.',
      },
      ...prev,
    ])
  }

  const ReprocessPayment = async (payment) => {
    const isConfirmed = window.prompt(
      'Tem certeza que deseja reprocessar esta cobrança? Digite "CONFIRMAR" para continuar.',
    )

    if (String(isConfirmed).toUpperCase() !== 'CONFIRMAR') {
      return setAlerts((prev) => [
        {
          type: 'error',
          title: 'Confirmação Recusada',
          msg: 'Para reprocessar uma cobrança é necessário confirmar.',
        },
        ...prev,
      ])
    }

    const payments = await getDocumentsWithQuery('_payments', 'idPayment', '==', payment.idPayment)

    const deletartodosPayments = payments.map(async (pay) => {
      // console.log('pay.id: ', pay.id)
      await deleteDocument('_payments', pay.id)
    })

    await Promise.all(deletartodosPayments)

    const { statusOld, ...paymentData } = payment

    // console.log(statusOld)

    const newPayment = {
      ...paymentData,
      status: statusOld ?? payment?.status,
      log: [
        {
          status: 'Pagamento reprocessado com status: ' + statusOld ?? payment?.status,
          time: TimestampNow(),
          origin: 'web/clients/newPayment/' + user.user.nome,
        },
        ...(paymentData?.log || []),
      ],
    }

    await addDocument('_payments', newPayment)
    await setSubDocument('clientes', id, 'payments', newPayment.id, newPayment)

    await FetchGetData()
    return setAlerts((prev) => [
      {
        type: 'success',
        title: 'Pagamento Reprocessado',
        msg: 'Solicitação de repossesamento enviado, aguarde a conclusão.',
      },
      ...prev,
    ])
  }

  const HandleReprocessPayment = async (value) => {
    await TryCatch(
      async () => {
        await ReprocessPayment(value)
      },
      setLoading,
      setAlerts,
    )
  }

  const HandleDeletePayment = async (value) => {
    await TryCatch(
      async () => {
        await DeletePayment(value)
      },
      setLoading,
      setAlerts,
    )
  }

  const HandleCancelPayment = async (value) => {
    await TryCatch(
      async () => {
        await CancelPayment(value)
      },
      setLoading,
      setAlerts,
    )
  }

  const HandleSelectPayment = async (value) => {
    await TryCatch(
      async () => {
        await selectPayment(value)
      },
      setLoading,
      setAlerts,
    )
  }

  const FetchGetData = async () => {
    await TryCatch(getData, setLoading, setAlerts)
  }

  const FetchGetForm = async () => {
    await TryCatch(getForm, setLoading, setAlerts)
  }

  useEffect(() => {
    FetchGetData()
    FetchGetForm()
  }, [])

  const payments = dataContext?.payments || []

  const dataFiltered =
    search !== ''
      ? payments.filter((payments) => {
          const searchString =
            `${payments.dt_created}||${payments.name}||${payments.value}||${payments.typePayment}||${payments?.responseOmie?.codigo_lancamento_omie}`.toLowerCase()
          return searchString.includes(search.toLowerCase())
        })
      : payments

  return {
    id,
    search,
    setSearch,
    navigate,
    infosContext,
    loading,
    setLoading,
    dataFiltered,
    FetchGetData,
    modalHistory,
    setModalHistory,
    dataContext,
    userName,
    HandleNewPayment,
    HandleSelectPayment,
    HandleDeletePayment,
    HandleCancelPayment,
    HandleReprocessPayment,
    HandleConsultarOsOmie,
    HandleConfirmPayment,
    formContext,
    setFormContext,
  }
}
